import { BetItem } from '../components/BettingSlipDrawer';
import { TopCombiItem } from '../api/types';
import { generateBetItemId } from './ticketHelpers';

function fmt(val?: string | null): string {
  if (!val) return '';
  const n = parseFloat(String(val));
  if (isNaN(n) || n <= 1) return '';
  return n.toFixed(2).replace('.', ',');
}

/**
 * Turn a Top Combi into ordinary accumulator legs (NOT a CustomBet). The list
 * response keeps the labelled legs in selections_preview (selections is null),
 * so fall back to it.
 */
export function buildCombiBetItems(item: TopCombiItem): BetItem[] {
  const legs = (item.selections?.length ? item.selections : item.selections_preview) || [];
  return legs.map((sel) => ({
    id: generateBetItemId(sel.event_id, sel.market_id, sel.outcome_id, sel.specifiers),
    matchId: sel.event_id,
    matchName: sel.event_name || '',
    betType: sel.outcome_id === '1' ? 'home' : sel.outcome_id === '3' ? 'away' : 'draw',
    tippLabel: sel.market_name && sel.outcome_name ? `${sel.market_name} – ${sel.outcome_name}` : (sel.outcome_name ?? ''),
    odds: fmt(sel.odds),
    eventId: sel.event_id,
    marketId: sel.market_id,
    outcomeId: sel.outcome_id,
    outcomeName: sel.outcome_name,
    specifiers: sel.specifiers,
  }));
}
